import { createTheme } from '@mantine/core'

export const theme = createTheme({
    primaryColor: 'darkLink',
    fontFamily: 'Roboto Condensed, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    headings: {
        fontFamily: 'Roboto Condensed, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    },
    colors: {
        brand: [
            '#e3f2fd',
            '#bbdefb',
            '#90caf9',
            '#64b5f6',
            '#42a5f5',
            '#2196f3',
            '#1e88e5',
            '#1976d2',
            '#1565c0',
            '#0d47a1',
        ],
        customGreen: [
            '#f0f7f1',  // lightest
            '#d4ebd6',  // very light
            '#b8dfbb',  // light
            '#9dd3a0',  // light-medium
            '#81c785',  // medium-light
            '#5a965e',  // base color (your RGB: 90, 150, 94)
            '#4e8352',  // medium-dark
            '#427046',  // dark
            '#365d3a',  // very dark
            '#2a4a2e',  // darkest
        ],
        customYellow: [
            '#fefdfb',  // lightest (very light cream)
            '#fdfbf7',  // very light
            '#fcf9f3',  // light
            '#fbf7ef',  // light-medium
            '#faf5eb',  // medium-light
            '#f8eed7',  // base color (your RGB: 248, 238, 215)
            '#e6d6c1',  // medium-dark
            '#d4beab',  // dark
            '#c2a695',  // very dark
            '#b08e7f',  // darkest
        ],
        darkLink: [
            '#f8f8f8',  // lightest
            '#e8e8e8',  // very light
            '#d8d8d8',  // light
            '#c8c8c8',  // light-medium
            '#888888',  // medium-light
            '#131918',  // base color (your RGB: 19, 25, 24)
            '#101514',  // medium-dark
            '#0d1110',  // dark
            '#0a0d0c',  // very dark
            '#070908',  // darkest
        ],
        // Platform-specific colors
        nintendo: [
            '#ffe6e6',  // lightest
            '#ffcccc',  // very light
            '#ffb3b3',  // light
            '#ff9999',  // light-medium
            '#ff8080',  // medium-light
            '#e30013',  // base color (RGB: 227, 0, 19)
            '#cc0011',  // medium-dark
            '#b3000f',  // dark
            '#99000d',  // very dark
            '#80000b',  // darkest
        ],
        xbox: [
            '#e6f7e6',  // lightest
            '#ccefcc',  // very light
            '#b3e7b3',  // light
            '#99df99',  // light-medium
            '#80d780',  // medium-light
            '#117111',  // base color (RGB: 17, 113, 17)
            '#0f650f',  // medium-dark
            '#0d590d',  // dark
            '#0b4d0b',  // very dark
            '#094109',  // darkest
        ],
        playstation: [
            '#e6f2ff',  // lightest
            '#cce5ff',  // very light
            '#b3d8ff',  // light
            '#99cbff',  // light-medium
            '#80beff',  // medium-light
            '#0065c5',  // base color (RGB: 0, 101, 197)
            '#005bb1',  // medium-dark
            '#00519d',  // dark
            '#004789',  // very dark
            '#003d75',  // darkest
        ],
        pc: [
            '#f5f5f5',  // lightest
            '#e8e8e8',  // very light
            '#d1d1d1',  // light
            '#b8b8b8',  // light-medium
            '#9e9e9e',  // medium-light
            '#000000',  // base color (RGB: 0, 0, 0)
            '#000000',  // medium-dark
            '#000000',  // dark
            '#000000',  // very dark
            '#000000',  // darkest
        ],
    },
    components: {
        Card: {
            defaultProps: {
                shadow: 'sm',
                radius: 'md',
            },
        },
        Button: {
            defaultProps: {
                radius: 'md',
            },
        },
        Input: {
            defaultProps: {
                radius: 'md',
            },
        },
    },
    breakpoints: {
        xs: '36em',
        sm: '48em',
        md: '62em',
        lg: '75em',
        xl: '88em',
    },
    // Dark mode support
    other: {
        // Custom CSS variables for dark mode
        '--mantine-color-scheme': 'light',
    },
}) 